import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';
import { isSafeHref } from '../../lib/utils/url.js';

/** XSS安全な markdown レンダラ。GFM（テーブル・打消し線・タスクリスト・自動リンク）対応 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ href, children: c, ...rest }) => {
            const safe = href && isSafeHref(href) ? href : undefined;
            return (
              <a href={safe} target="_blank" rel="noopener noreferrer" {...rest}>
                {c}
              </a>
            );
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
